import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Grid, Link, TextField, Typography } from '@material-ui/core'

import { BasePhoneInput, LoadingFeedback, Select, BaseDialog } from 'components'

import useSnackbar from 'hooks/useSnackbar'
import useAuth from 'hooks/useAuth'

import schema from './schema'
import constants from 'constants/index'
import * as service from 'service'
import helpers from 'helpers'

const SolicitationContactModal = ({ open, onClose, setOpen }) => {
  const {
    SOLICITATION_CONTACT_CONTROL_ITEMS,
    SEGMENT_OPTIONS,
    EMPLOYEES_OPTIONS,
  } = constants.contactQuestionnaire

  const [loading, setLoading] = useState(false)

  const { mixpanel } = helpers
  const { user, userCompany } = useAuth()

  const { control, errors, handleSubmit } = useForm({
    validationSchema: schema,
    defaultValues: {
      name: user?.name || '',
      email: userCompany?.company?.email || '',
      phone: userCompany?.company?.phone || '',
      document:
        helpers.formatters.document.identify(userCompany?.company?.document) ||
        '',
      companyName: userCompany?.company?.name || '',
      employees: '',
      segment: '',
    },
  })

  const snackbar = useSnackbar()

  const handleOnChange = (event, name) => {
    if (name === 'document')
      return helpers.formatters.document.identify(event?.target?.value, true)

    return event?.target?.value
  }

  const handleSelectOptions = (stringArray) => {
    return stringArray?.map((item) => ({
      id: item,
      name: item,
    }))
  }

  const segmentsOptions = handleSelectOptions(SEGMENT_OPTIONS)
  const employeesOptions = handleSelectOptions(EMPLOYEES_OPTIONS)

  const onSubmit = async (data) => {
    try {
      setLoading(true)

      await service.dponet.rdStation.contactSpecialistRdStation({
        ticket: { ...data, scope: 'dponet-supplier' },
      })

      snackbar.open({
        message: 'Solicitação de contato enviada com sucesso!',
        variant: 'success',
      })
      mixpanel.track('RDStation', 'Solicitação de contato', {
        action: 'solicitar_contato_especialista-dponet',
      })
    } catch (error) {
      console.error(error)
      snackbar.open({
        message: helpers.formatters.errorMessage(error),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      setOpen={setOpen}
      title="Solicitação de contato"
      closeButtonText="Cancelar"
      actionButtonText="Solicitar contato"
      formRef="solicitar-contato-especialista-checkout-fornecedor-dponet"
      dialogSize="xs"
    >
      <LoadingFeedback open={loading} />
      <form
        id="solicitar-contato-especialista-checkout-fornecedor-dponet"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography fontWeight={600} color="primary">
              Adequação a LGPD completa e com banner de cookies ilimitado!
            </Typography>
            <Typography color="primary">
              Fale com um de nossos especialistas.
            </Typography>
          </Grid>
          {SOLICITATION_CONTACT_CONTROL_ITEMS.map((item, index) => (
            <Grid key={index} item xs={12} md={6}>
              {item?.name === 'phone' ? (
                <Controller
                  as={
                    <BasePhoneInput
                      label={item.label}
                      error={!!errors?.[item.name]}
                      helperText={errors?.[item.name]?.message}
                      fullWidth
                    />
                  }
                  control={control}
                  name={item.name}
                />
              ) : (
                <Controller
                  as={
                    <TextField
                      label={item.label}
                      error={!!errors?.[item.name]}
                      helperText={errors?.[item.name]?.message}
                      fullWidth
                      type={item?.type || 'text'}
                    />
                  }
                  control={control}
                  name={item.name}
                  onChange={([event]) => {
                    const value = handleOnChange(event, item.name)
                    return value
                  }}
                />
              )}
            </Grid>
          ))}
          <Grid item xs={12} md={6}>
            <Controller
              as={
                <Select
                  label="Segmento"
                  items={segmentsOptions}
                  error={!!errors?.segment}
                  helperText={errors?.segment?.message}
                  fullWidth
                />
              }
              control={control}
              name="segment"
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              as={
                <Select
                  label="Quantos colaboradores têm a sua organização?"
                  items={employeesOptions}
                  error={!!errors?.employees}
                  helperText={errors?.employees?.message}
                  fullWidth
                />
              }
              control={control}
              name="employees"
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" color="primary">
              Ao informar meus dados, estou ciente das diretrizes da{' '}
              <Link
                fontWeight={600}
                href="https://www.dponet.com.br/politica-de-privacidade-do-dponet/"
                target="_blank"
              >
                Política de Privacidade
              </Link>
              &nbsp;e os&nbsp;
              <Link
                fontWeight={600}
                href="https://www.dponet.com.br/termos-e-condicoes-da-oferta-de-maio-de-2025/"
                target="_blank"
              >
                termos da oferta da DPOnet
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </form>
    </BaseDialog>
  )
}

export default SolicitationContactModal
